<template>
  <div>
    <div>
      <h2 class="th-title">Daftar Organisasi</h2>
    </div>
    <a-card>
      <div class="d-flex justify-content-between">
        <a-input-search
          placeholder="Cari Nama Organisasi..."
          v-model:value="search"
          style="width: 250px;"
          class="mb-3"
        />
        <router-link :to="{ path: `/organizations/create` }">
          <a-button> <PlusOutlined />Tambah Organisasi </a-button>
        </router-link>
      </div>
      <div>
        <a-table :columns="columns" :data-source="data" :loading="loading" bordered>
          <template #name="{ text, record }">
            <router-link :to="{ path: `/organizations/${record.id}` }" class="vb__utils__link">
              {{ text }}
            </router-link>
          </template>
          <template #action="{ record }">
            <a-button type="danger" @click="openDeleteModal(record.id)">
              <RestOutlined :style="{ color: 'white' }" />
            </a-button>
          </template>
        </a-table>
      </div>
    </a-card>

    <a-modal
      v-model:visible="isDeleteModalVisible"
      title="Konfirmasi Penghapusan"
      ok-text="Hapus"
      ok-type="danger"
      cancel-text="Batal"
      centered
      @ok="handleDelete"
      @cancel="closeDeleteModal"
    >
      <p>Apakah Anda yakin ingin menghapus organisasi ini? Tindakan ini tidak dapat dibatalkan.</p>
    </a-modal>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import { notification } from 'ant-design-vue'
import { PlusOutlined, RestOutlined } from '@ant-design/icons-vue'
import { getOrganizations, deleteOrganization } from '../../services/axios/modc/organization'

const columns = [
  { title: 'No', dataIndex: 'key', key: 'key' },
  { title: 'Nama Organisasi', dataIndex: 'name', key: 'name', slots: { customRender: 'name' } },
  { title: 'Organization Sign', dataIndex: 'organizationSign', key: 'organizationSign' },
  { title: 'Email', dataIndex: 'email', key: 'email' },
  { title: 'PIC', dataIndex: 'PIC', key: 'PIC' },
  { title: 'Mobile Number', dataIndex: 'mobileNumber', key: 'mobileNumber' },
  // Tambahkan kolom Action
  { title: 'Action', key: 'action', slots: { customRender: 'action' }, align: 'center' },
]

export default {
  components: {
    PlusOutlined,
    RestOutlined,
  },

  setup() {
    const data = ref([])
    const search = ref('')
    const loading = ref(false)

    // State untuk mengontrol modal
    const isDeleteModalVisible = ref(false)
    const organizationIdToDelete = ref(null)

    // Fungsi untuk mengambil data organisasi
    const fetchOrganizations = async (searchTerm = '') => {
      loading.value = true
      try {
        const { organization } = await getOrganizations(searchTerm)
        data.value = organization.map((org, index) => ({
          ...org,
          key: index + 1,
        }))
      } catch (error) {
        console.error('Gagal mengambil data organisasi:', error)
        notification.error({
          message: 'Gagal Memuat Data',
          description: 'Terjadi kesalahan saat mengambil daftar organisasi.',
        })
      } finally {
        loading.value = false
      }
    }

    // Panggil saat komponen dimuat
    onMounted(fetchOrganizations)

    // Panggil saat ada pencarian
    watch(search, newValue => {
      fetchOrganizations(newValue)
    })

    // Fungsi utama untuk menghapus organisasi
    const deleteOrg = async orgId => {
      try {
        await deleteOrganization(orgId)
        notification.success({
          message: 'Berhasil',
          description: 'Organisasi telah berhasil dihapus.',
        })
        await fetchOrganizations() // Muat ulang daftar setelah sukses
      } catch (error) {
        console.error('Gagal menghapus organisasi:', error)
        notification.error({
          message: 'Gagal Menghapus',
          description: 'Terjadi kesalahan saat mencoba menghapus organisasi.',
        })
      }
    }

    // Fungsi untuk membuka modal
    const openDeleteModal = orgId => {
      organizationIdToDelete.value = orgId
      isDeleteModalVisible.value = true
    }

    // Fungsi untuk menutup modal
    const closeDeleteModal = () => {
      isDeleteModalVisible.value = false
      organizationIdToDelete.value = null
    }

    // Fungsi yang dipanggil saat tombol OK modal ditekan
    const handleDelete = () => {
      if (organizationIdToDelete.value) {
        deleteOrg(organizationIdToDelete.value)
      }
      closeDeleteModal()
    }

    return {
      data,
      columns,
      search,
      loading,
      isDeleteModalVisible,
      openDeleteModal,
      closeDeleteModal,
      handleDelete,
    }
  },
}
</script>
